import api from "../api";
import apiNoAuth from "../apiNoAuth";

export class SpatialService {

    static fetchLandUses(land_use_id=null){return apiNoAuth.get(land_use_id === null ? `spatial/landuse-area`
    : `spatial/landuse-area?land_use_id=${land_use_id}`).catch(e=>console.log(e))}

    static fetchLandUsesPerLocality(locality_id = null,land_use_id=null){return apiNoAuth.get(land_use_id === null
        ? locality_id === null ? `spatial/landuse-area` : `spatial/landuse-area?locality_id=${locality_id}`
        : `spatial/landuse-area?locality_id=${locality_id}&&land_use_id=${land_use_id}`).catch(e=>console.log(e))}

    static updatePartyPicture(formData) {
        return api.post('spatial/update/party-picture',formData,{headers:{'Content-Type':'multipart/form-data'}}).catch(e=>{console.log(e);})
    }
}